import React, { forwardRef } from 'react'
import { useStyles } from './styles'
import { Dropdown } from '../../root/components/common'
import {
    CONNECTIVITY_ID,
    INFESTED_ID,
    TRIGGERED_ID,
    getEventTypeListItems
} from './constants'
import classNames from 'classnames'
import CustomCheckboxV2 from '../../root/components/common/checkbox-v2'
import Icon from '@mdi/react'
import {
    mdiCloseCircleOutline,
    mdiLightningBoltOutline,
    mdiWifi
} from '@mdi/js'

export const HeatmapType = forwardRef(
    (
        {
            toggleDropDown,
            setToggleDropDown,
            heatmapFilters,
            applyHeatmapFilter,
            locale
        },
        ref
    ) => {
        const classes = useStyles()
        const { reportTypes: checkedHeatmapTypes } = heatmapFilters

        const heatmapTypesIcons = {
            [INFESTED_ID]: () => (
                <Icon path={mdiLightningBoltOutline} size={1} color="grey" />
            ),
            [TRIGGERED_ID]: () => (
                <Icon path={mdiCloseCircleOutline} size={1} color="grey" />
            ),
            [CONNECTIVITY_ID]: () => (
                <Icon path={mdiWifi} size={1} color="grey" />
            )
        }

        const heatmapTypes = getEventTypeListItems(locale).map(item => ({
            ...item,
            icon: heatmapTypesIcons[item.id]
        }))

        const handleCheckboxClick = checkedItem => {
            if (
                checkedHeatmapTypes.some(
                    selectedItem => checkedItem.id === selectedItem.id
                )
            ) {
                applyHeatmapFilter('reportTypes', [])
                return
            }

            applyHeatmapFilter('reportTypes', [checkedItem])
        }

        return (
            <Dropdown
                anchorEl={ref.current}
                isOpen={toggleDropDown}
                close={() => setToggleDropDown(false)}
                className={classes.dropdown}
                customWrapper={classNames(
                    classes.dropdownCustomWrapper,
                    classes.heatmapTypeDropdown
                )}
                placement="down"
            >
                <div className={classes.heatmapTypeDropdownWrapper}>
                    {heatmapTypes.map((item, index) => {
                        return (
                            <CustomCheckboxV2
                                key={index}
                                label={item.text}
                                description={item.description}
                                icon={item.icon}
                                checked={checkedHeatmapTypes.some(
                                    selectedItem => item.id === selectedItem.id
                                )}
                                onClick={() => handleCheckboxClick(item)}
                            />
                        )
                    })}
                </div>
            </Dropdown>
        )
    }
)
